
import { Box, Typography } from "@mui/material";
import { motion, useReducedMotion } from "framer-motion";
import PageLayout from "../../layoutcontainers/PageLayout";
import everGuardLogo from "../../assest/LogoAndFavicon/EverguardLogo2026.svg";
import "./everguardLogin.css";

const heroImage =
    "https://app.banani.co/api/flow-image/4%3A5%0Adiverse%20happy%20office%20team%20laughing%20together%2C%20bright%20studio%20portrait%2C%20mint%20green%20background%2C%20editorial%20photography%2C%20fresh%20SaaS";

function EverGuardLoginLayout({ children }) {
    const shouldReduceMotion = useReducedMotion();

    return (
        <PageLayout height="100%" showNavbar disableFooter>
            <Box className="eg-login-shell">
                <Box className="eg-login-panel">
                    <Box className="eg-login-brand">
                        <motion.img
                            src={everGuardLogo}
                            alt="EverGuard Insurance Broking Services"
                            initial={false}
                            animate={{ scale: shouldReduceMotion ? 1 : [1, 1.015, 1] }}
                            transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
                        />
                    </Box>

                    <motion.div
                        className="eg-login-content"
                        initial={false}
                        animate={{ x: shouldReduceMotion ? 0 : [8, 0] }}
                        transition={{ duration: 0.55, ease: "easeOut" }}
                    >
                        <Typography className="eg-login-eyebrow">EVERGUARD HRMS</Typography>
                        <Typography component="h1" className="eg-login-title">
                            Welcome back
                        </Typography>
                        <Typography className="eg-login-subtitle">
                            Sign in to securely access your workday.
                        </Typography>
                        {children}
                    </motion.div>

                    <Box component="footer" className="eg-login-footer">
                        <span>© 2026&nbsp;
                            <a href="https://www.keelis.com/" target="_blank" rel="noopener noreferrer">
                                Keel info solution pvt. ltd.
                            </a>
                        </span>
                        <nav aria-label="Legal and support links">
                            <a href="https://www.everguardinsurancebrokers.com/" target="_blank" rel="noopener noreferrer">
                                Company
                            </a>
                            <a className="eg-login-support-contact" href="tel:+919087599222">
                                Support: +91 90875 99222
                            </a>
                            <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">
                                Privacy
                            </a>
                            <a href="mailto:support@keelis.com?subject=EverGuard%20HRMS%20terms">
                                Terms
                            </a>
                        </nav>
                    </Box>
                </Box>

                <Box className="eg-login-visual">
                    <motion.img
                        className="eg-login-hero-image"
                        src={heroImage}
                        alt="Team working together"
                        initial={false}
                        animate={{ scale: shouldReduceMotion ? 1 : [1, 1.045, 1] }}
                        transition={{ duration: 16, repeat: Infinity, ease: "easeInOut" }}
                    />
                    <Box className="eg-login-visual-shade" />
                    <motion.div
                        className="eg-login-message"
                        initial={false}
                        animate={{ y: shouldReduceMotion ? 0 : [10, 0] }}
                        transition={{ duration: 0.65, delay: 0.1, ease: "easeOut" }}
                    >
                        <Typography className="eg-login-message-label">
                            PROTECTION THAT MOVES WITH YOU
                        </Typography>
                        <Typography component="h2">
                            People first.<br />
                            Protected always.
                        </Typography>
                        <Typography className="eg-login-message-copy">
                            One secure place for your team, benefits, and workday essentials.
                        </Typography>
                        <Box className="eg-login-trust-points">
                            <motion.span
                                initial={false}
                                animate={{ opacity: 1, x: shouldReduceMotion ? 0 : [8, 0] }}
                                transition={{ duration: 0.45, delay: 0.3, ease: "easeOut" }}
                            >
                                <i /> Secure employee access
                            </motion.span>
                            <motion.span
                                initial={false}
                                animate={{ opacity: 1, x: shouldReduceMotion ? 0 : [8, 0] }}
                                transition={{ duration: 0.45, delay: 0.42, ease: "easeOut" }}
                            >
                                <i /> Support when you need it
                            </motion.span>
                        </Box>
                    </motion.div>
                    <motion.div
                        className="eg-login-caption"
                        initial={false}
                        animate={{ opacity: 1, y: shouldReduceMotion ? 0 : [6, 0] }}
                        transition={{ duration: 0.45, delay: 0.35, ease: "easeOut" }}
                    >
                        <span>EVERGUARD</span>
                        <span>INSURANCE BROKING SERVICES</span>
                    </motion.div>
                </Box>
            </Box>
        </PageLayout>
    );
}

export default EverGuardLoginLayout;
